import { useTheme } from "styled-components";
import { Svg, SvgProps } from "..";

const BunnyKnownPlaceholder: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  const theme = useTheme();
  const primaryColor = theme.isDark ? "#3C3742" : "#e9eaeb";
  const secondaryColor = theme.isDark ? "#666171" : "#bdc2c4";

  return (
    <Svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="80.000000pt" height="80.000000pt" viewBox="0 0 256.000000 322.000000"
    preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,322.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M373 2832 l-161 -387 -33 -330 -32 -330 -74 -195 c-46 -123 -73 -210
-73 -235 0 -49 186 -750 208 -785 8 -14 93 -113 187 -220 l172 -195 254 -75
254 -75 205 0 205 0 254 75 253 74 180 205 c99 112 184 214 189 225 23 53 199
735 199 771 0 26 -25 105 -72 225 l-71 185 -37 350 -37 350 -153 360 c-172
407 -166 395 -183 395 -7 0 -104 -164 -216 -365 -113 -204 -209 -365 -217
-365 -7 0 -71 16 -141 35 -70 19 -139 35 -153 35 -14 0 -88 -17 -165 -38
l-139 -39 -206 368 c-128 231 -211 369 -220 369 -10 0 -66 -122 -177 -388z
m308 108 c67 -122 120 -222 118 -224 -2 -2 -82 -20 -176 -40 -160 -34 -174
-36 -196 -21 -26 17 -47 55 -47 86 0 11 36 106 81 212 84 199 88 207 94 207 2
0 59 -99 126 -220z m1418 11 c44 -107 81 -202 81 -212 0 -29 -21 -67 -46 -84
-21 -13 -38 -12 -196 21 -95 20 -175 38 -177 40 -4 3 80 160 192 357 27 49 53
85 57 80 4 -4 44 -95 89 -202z m-1713 -308 c2 -26 4 -52 5 -58 2 -13 -194
-726 -198 -722 -2 2 11 134 27 293 30 283 31 291 70 384 22 52 47 112 55 134
20 49 37 36 41 -31z m1872 -73 l51 -125 25 -250 c14 -137 28 -268 30 -290 4
-30 3 -35 -4 -20 -13 27 -193 687 -191 700 1 6 3 31 5 56 3 49 14 76 25 62 4
-4 31 -64 59 -133z m-1381 17 c34 -61 65 -119 68 -127 4 -11 -41 -57 -146
-150 -148 -132 -181 -154 -192 -128 -3 7 -42 100 -87 207 -53 126 -80 201 -76
216 5 19 24 26 168 57 90 20 172 36 183 37 15 1 34 -25 82 -112z m1060 76
c151 -32 174 -40 179 -58 3 -12 -27 -96 -76 -215 -45 -107 -84 -201 -87 -208
-3 -7 -14 -12 -23 -10 -24 4 -321 269 -318 283 7 26 133 245 142 245 5 0 87
-17 183 -37z m-606 -708 l39 -170 -35 -195 c-19 -107 -37 -216 -41 -242 -3
-27 -10 -48 -14 -48 -4 0 -13 39 -20 88 -6 48 -18 116 -26 152 -7 36 -21 106
-30 155 l-16 90 36 153 c20 84 36 162 36 173 0 14 5 19 16 17 13 -2 26 -43 55
-173z m-224 -172 c26 -101 41 -180 38 -198 -3 -16 -9 -78 -14 -137 -5 -59 -13
-113 -17 -120 -5 -7 -9 -24 -10 -38 -1 -14 -13 -132 -28 -262 -14 -131 -26
-247 -26 -258 0 -13 -6 -20 -17 -20 -10 1 -101 29 -203 63 -139 47 -186 66
-188 80 -2 9 26 80 62 157 36 77 68 152 71 167 6 27 6 27 -10 8 -9 -11 -48
-86 -87 -167 -40 -82 -75 -148 -79 -148 -14 0 -447 473 -443 484 2 6 82 43
177 82 138 57 180 70 215 68 23 -2 48 -6 55 -10 6 -4 4 2 -6 14 -10 11 -17 28
-15 37 1 8 104 99 227 200 169 139 228 182 240 176 9 -6 31 -71 58 -178z m661
-13 c117 -96 212 -181 212 -189 0 -8 -8 -23 -17 -33 -16 -18 -16 -19 7 -11 14
4 41 8 60 8 39 -1 367 -133 374 -151 6 -15 -433 -486 -446 -478 -6 4 -39 66
-74 138 -35 72 -73 145 -85 161 l-21 30 6 -27 c3 -14 35 -89 71 -166 36 -78
65 -148 65 -157 0 -9 -15 -22 -32 -30 -57 -23 -367 -119 -372 -114 -4 4 -58
490 -60 539 -1 14 -5 31 -10 38 -4 7 -12 61 -17 120 -5 59 -12 120 -15 136 -8
35 73 356 94 373 18 15 -2 30 260 -187z m-1384 -677 c185 -202 198 -222 162
-245 -6 -3 -78 -56 -161 -117 -82 -60 -153 -107 -156 -103 -4 4 -20 61 -38
127 -26 100 -32 151 -41 310 -5 105 -12 215 -15 245 l-6 55 34 -35 c19 -19
118 -126 221 -237z m2029 22 c-11 -208 -17 -255 -43 -354 -17 -62 -34 -120
-38 -127 -5 -9 -48 17 -157 97 -83 61 -155 114 -161 117 -31 20 -23 44 39 110
270 295 370 402 372 400 1 -2 -4 -111 -12 -243z m-1228 139 c25 -15 51 -37 57
-50 15 -33 61 -33 76 0 9 21 88 76 109 76 7 0 55 -457 53 -513 0 -16 -5 -15
-50 8 -43 22 -62 25 -150 25 -88 0 -107 -3 -150 -25 l-50 -25 0 22 c-1 54 45
508 51 508 4 0 28 -12 54 -26z m-150 -594 c-12 -112 -3 -102 -133 -148 -65
-23 -122 -42 -127 -42 -11 0 -145 360 -139 372 2 3 94 -24 205 -60 l201 -67
-7 -55z m884 152 c-6 -15 -35 -94 -65 -177 -30 -82 -59 -154 -64 -159 -4 -4
-61 11 -128 35 -133 47 -126 40 -137 144 l-7 60 199 66 c109 36 201 64 205 62
4 -2 3 -16 -3 -31z m-1245 -173 l68 -190 -72 -109 c-40 -60 -78 -114 -84 -119
-8 -7 -59 44 -175 176 -158 180 -162 186 -144 204 41 40 318 237 328 233 6 -3
42 -90 79 -195z m1488 62 c70 -51 132 -99 138 -106 9 -11 -25 -55 -152 -199
-113 -128 -166 -182 -174 -175 -6 5 -44 59 -84 119 l-72 109 67 188 c36 103
72 191 78 195 6 4 25 -3 42 -16 16 -12 87 -64 157 -115z m-1077 -221 c27 -27
68 -56 90 -64 45 -16 47 -15 -76 -35 -63 -10 -69 -9 -179 27 l-114 39 69 26
c85 32 148 55 155 56 2 1 27 -21 55 -49z m537 16 c51 -19 102 -38 112 -42 15
-6 -8 -17 -94 -46 -110 -36 -116 -37 -179 -27 -123 20 -122 20 -75 35 23 8 61
36 89 64 27 28 50 50 52 50 1 0 44 -15 95 -34z m-751 -138 l98 -62 30 -111
c17 -60 31 -113 31 -117 0 -4 -10 -3 -22 2 -36 16 -365 110 -384 110 -10 0
-14 5 -11 15 10 23 147 225 154 225 3 0 50 -28 104 -62z m999 -43 c82 -123 88
-135 66 -135 -19 0 -348 -94 -383 -110 -30 -12 -29 -11 8 119 l31 107 96 62
c54 34 100 62 104 62 4 0 39 -47 78 -105z m-723 -70 l133 -36 133 36 c73 19
136 35 139 35 7 0 -52 -203 -63 -215 -5 -5 -54 -14 -110 -20 -106 -12 -289 0
-307 20 -12 12 -71 215 -64 215 3 0 66 -16 139 -35z"/>
</g>

    </Svg>
  );
};

export default BunnyKnownPlaceholder;
